import { Form, Button } from "antd";
const FormButton = ({ children }) => {
    return (
        <Form.Item>
            <Button type='primary' htmlType='submit' block>
                {children}
            </Button>
        </Form.Item>
    );
};

export default FormButton;
